import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const index = ({ name, color }) => {
  return (
    <Box
      sx={{
        backgroundColor: color,
        borderRadius: 12,
        padding: '2px 8px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Mulish',
          fontSize: '10px',
          lineHeight: '12px',
          color: '#FFF',
          letterSpacing: '0.005em',
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};
index.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};
export default index;
